import { render, staticRenderFns } from "./expertFeeArgu.vue?vue&type=template&id=4c20c334&scoped=true"
import script from "./expertFeeArgu.vue?vue&type=script&lang=js"
export * from "./expertFeeArgu.vue?vue&type=script&lang=js"
import style0 from "./expertFeeArgu.vue?vue&type=style&index=0&id=4c20c334&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c20c334",
  null
  
)

export default component.exports